"use strict";
/**
 * https://figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8913%3A50852&t=NtjA8Sv8wCXUrDIj-1
 */
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("../colors");
const common_1 = require("../tokens/common");
const pinInputTokens = {
    'pin-input-bg': (0, colors_1.getColorValue)('transparent'),
    'pin-input-bg-disabled': (0, colors_1.getColorValue)('grey.200'),
    'pin-input-bg-focus': (0, colors_1.getColorValue)('transparent'),
    'pin-input-border': (0, common_1.getCommonTokenValue)('border'),
    'pin-input-border-disabled': (0, colors_1.getColorValue)('grey.400'),
    'pin-input-border-focus': (0, colors_1.getColorValue)('blue.200'),
    'pin-input-text': (0, common_1.getCommonTokenValue)('text-primary'),
    'pin-input-text-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'pin-input-text-focus': (0, common_1.getCommonTokenValue)('text-primary'),
};
exports.default = pinInputTokens;
